import React, { useState } from "react";
import { Link } from "react-router-dom";
import TableView from "../TableView";
import ConfirmationModal from "../ConfirmationModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/pro-regular-svg-icons";

const TenantsTab = ({
  tenantPublicId,
  agreementPublicId,
  agreement,
  filteredTenants,
  selectedTenants,
  setSelectedTenants,
  handleDeleteTenant,
}) => {
  const [confirmState, setConfirmState] = useState({
    isOpen: false,
    title: "",
    confirm: () => {},
  });

  const handleConfirmDelete = (tenantPublicId) => {
    const tenant = filteredTenants.find(t => t.tenantPublicId === tenantPublicId);
    setConfirmState({
      isOpen: true,
      title: `Are you sure you want to delete ${tenant?.displayName || "this tenant"}?`,
      confirm: () => handleDeleteTenant(tenantPublicId),
    });
  };

  return (
    <>
      <div className="flex justify-between items-center">
        <h2>Tenants in: {agreement?.name}</h2>
        <Link to={`/${agreementPublicId}/create-tenant`} className="btn-primary">
          <FontAwesomeIcon icon={faPlus} className="mr-2 text-lg" />
          Create tenant
        </Link>
      </div>
      <TableView
        data={filteredTenants}
        selectedRows={selectedTenants}
        setSelectedRows={setSelectedTenants}
        noDelete={false}
        noEdit={false}
        noCheckbox={true}
        columns={[
          { key: "displayName", label: "Name" },
          { key: "createdBy", label: "Created by" },
          { key: "domain", label: "Domain" },
          { key: "tenantPublicId", label: "Tenant ID" },
        ]}
        primaryKey="tenantPublicId"
        basePath={`/${agreementPublicId}`}
        handleDelete={handleConfirmDelete}
      />
      <ConfirmationModal
        isOpen={confirmState.isOpen}
        title={confirmState.title}
        onClose={() => setConfirmState((s) => ({ ...s, isOpen: false }))}
        onConfirm={() => {
          setConfirmState((s) => ({ ...s, isOpen: false }));
          confirmState.confirm();
        }}
      />
    </>
  );
};

export default TenantsTab;
